import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsPolicyOption extends SnModel {
  @Expose()
  public type: string;

  @Expose()
  public attributes: any[];
}

export class FsPolicyOptionResponse extends SnModel {
  public rules: FsPolicyOption[];

  public conditions: FsPolicyOption[];
}
